export const CommonProvinceCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Province',
    path: '/sistema/geografiche/italia/provincia',
  },
];
